"use client";

import NextLink from "next/link";
import type { ComponentProps } from "react";
import { localePath } from "@/lib/i18n";
import { useLang } from "./lang-context";

/**
 * next/link that keeps the visitor in their language: an internal href ("/videos") gets the page's
 * language prefix ("/de/videos"; English has none, lib/i18n.ts). Outside the site's pages (the admin)
 * there's no language and hrefs are left as they are.
 */
export default function Link({ href, ...props }: ComponentProps<typeof NextLink>) {
  const lang = useLang();
  const localized = typeof href === "string" ? localePath(lang, href) : href.pathname ? { ...href, pathname: localePath(lang, href.pathname) } : href;
  return <NextLink href={localized} {...props} />;
}
